module.exports = __webpack_public_path__ + "static/pbqph-logo-d669602c620a3671805a8c79c74aadc0.png";